export function formatDateKey(year: number, month: number, day: number): string {
  return `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

export function addMonths(d: Date, delta: number): Date {
  return new Date(d.getFullYear(), d.getMonth() + delta, 1);
}

export const DOW_LABELS = ["M", "T", "W", "T", "F", "S", "S"];

export type MonthGrid = {
  year: number;
  mo: number;
  daysInMonth: number;
  firstDow: number;
  todayKey: string;
  atMin: boolean;
  atMax: boolean;
  monthLabel: string;
};

export function getMonthGrid(month: Date, minMonth: Date): MonthGrid {
  const year = month.getFullYear();
  const mo = month.getMonth();
  const daysInMonth = new Date(year, mo + 1, 0).getDate();
  const firstDow = (new Date(year, mo, 1).getDay() + 6) % 7; // Mon=0
  const todayKey = new Intl.DateTimeFormat("en-CA").format(new Date());

  const now = new Date();
  const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const atMin =
    month.getFullYear() === minMonth.getFullYear() && month.getMonth() === minMonth.getMonth();
  const atMax =
    month.getFullYear() === currentMonthStart.getFullYear() &&
    month.getMonth() === currentMonthStart.getMonth();

  const monthLabel = new Intl.DateTimeFormat("en-US", {
    month: "long",
    year: "numeric",
  }).format(month);

  return { year, mo, daysInMonth, firstDow, todayKey, atMin, atMax, monthLabel };
}
